import $ from "jquery";

export const navMobileHeight = () => {
    const padding = 50;
    const headerHeight = $('.header').height();
    const footerHeight = $('.nav-mobile__footer').height();
    let navMobileHeight = $(window).height() - headerHeight - footerHeight;

    $('.nav-mobile__list').css({
        height: (navMobileHeight - padding) + 'px'
    });

    $('.nav-mobile__inner').css({
        height: navMobileHeight + 'px'
    })
};
